import { parseDate, formatDate } from '@/utils';

export const DateRangeMapper = {
    toString: (value) => {
        return JSON.stringify({
            start: formatDate(value.start),
            end: formatDate(value.end)
        });
    },
    parse: (value) => {
        const queryValue = JSON.parse(value);
        const start = parseDate(queryValue.start);
        const end = parseDate(queryValue.end);
        return start && end ? { start, end } : null;
    }
};
